import { Component } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutocompleteComponent } from "common";
import { BrokerService } from "../../broker/broker.service";
import { BrokerListItemData, BrokerQueryParams } from "../../broker/broker.model";

@Component({
    selector: "ifb-broker-name-input",
    templateUrl: "../../../../../common/src/lib/ui/autocomplete/autocomplete.component.html",
    styleUrls: [
        "../../../../../common/src/lib/ui/autocomplete/autocomplete.component.css",
    ],
    standalone: false
})
export class BrokerNameInputComponent extends AutocompleteComponent {
  constructor(private brokerService: BrokerService) {
    super();
  }

  label = "Broker";

  optionFilter: (input: string | BrokerListItemData) => Observable<any[]> = (
    input
  ) =>
    input
      ? this.brokerService
          .query(new BrokerQueryParams({
            name: typeof input !== "string" ? input.name : input,
            active: true,
            limit: 10,
          }))
          .pipe(map((result) => result.values))
      : EMPTY;

  optionLabelKey = "name";
}
